function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { createContext, useMemo, useContext } from 'react';
import { jsx } from 'react/jsx-runtime';
const defaultValues = {
  global: {
    readTime: 'read time',
    videoDuration: '',
    author: 'Author',
    by: 'By',
    search: 'Search',
    suggestedTopics: 'Suggested Topics',
    searchForTopicOrArticle: 'Search for a topic or article',
    subscribed: 'You’re subscribed!',
    submit: 'Submit',
    emailPlaceholder: 'Enter Email',
    sortBy: 'Sort by',
    newest: 'Newest',
    oldest: 'Oldest',
    article: 'article',
    articles: 'articles',
    availableFor: 'Available For',
    protocols: 'Protocols'
  },
  blog: {},
  cloud: {}
};
const MicrocopyContext = /*#__PURE__*/createContext(defaultValues);
function MicrocopyProvider({
  children,
  microcopies
}) {
  const values = useMemo(() => {
    if (!microcopies) return;
    return Object.keys(microcopies).reduce((acc, key) => {
      const defiendGroup = microcopies[key];
      const defaultGroup = defaultValues[key];
      return _objectSpread(_objectSpread({}, acc), {}, {
        [key]: _objectSpread(_objectSpread({}, defaultGroup), defiendGroup)
      });
    }, {
      global: undefined,
      blog: undefined,
      cloud: undefined
    });
  }, [microcopies]);
  return /*#__PURE__*/jsx(MicrocopyContext.Provider, {
    value: values || defaultValues,
    children: children
  });
}
const useMicrocopyContext = () => useContext(MicrocopyContext);
const useGlobalMicrocopy = () => useMicrocopyContext();
export { MicrocopyProvider, useGlobalMicrocopy, useMicrocopyContext };
//# sourceMappingURL=MicrocopyProvider.js.map
